import { render, staticRenderFns } from "./PillBadge.vue?vue&type=template&id=06f1e650&scoped=true&"
import script from "./PillBadge.vue?vue&type=script&lang=js&"
export * from "./PillBadge.vue?vue&type=script&lang=js&"
import style0 from "./PillBadge.vue?vue&type=style&index=0&id=06f1e650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1e650",
  null
  
)

export default component.exports